import { useAppDispatch } from "hooks";
import React, { memo, useCallback, useEffect, useState } from "react";
import { actionAccountClear } from "store/auth";
import { getAuthTokens, updateAuthTokens } from "utils/cookies";
import { APIFree } from "utils/service";
import { AxiosInterceptorPost } from "./post";
import { AxiosInterceptorsRefreshToken } from "./refresh-token";
import { AxiosInterceptorsToken } from "./token";

interface Props {
  children: React.ReactNode;
}

export const AxiosInterceptorsProvider = memo<Props>(({ children }) => {
  const [error, setError] = useState<Error>();
  const dispatch = useAppDispatch();
  const onRefresh = useCallback(async () => {
    const {
      token: Token,
      refreshToken: RefreshToken,
      expires,
    } = getAuthTokens();

    if (!Token || !RefreshToken || !expires) {
      throw new Error("token-not-found");
    }

    const {
      data: { token, refreshToken },
    } = await APIFree.api.authRefreshTokenCreate({
      token: Token,
      refreshToken: RefreshToken,
    });

    if (!token || !refreshToken) {
      throw new Error("refresh-are-empty");
    }

    return { token, refreshToken, expires };
  }, []);

  useEffect(() => {
    if (error) {
      updateAuthTokens();
      dispatch(actionAccountClear());
      setError(undefined);
    }
  }, [error, dispatch]);

  return (
    <AxiosInterceptorsToken>
      <AxiosInterceptorsRefreshToken
        onRefresh={onRefresh}
        onError={setError}
        onSuccess={updateAuthTokens}
      >
        <AxiosInterceptorPost>{children}</AxiosInterceptorPost>
      </AxiosInterceptorsRefreshToken>
    </AxiosInterceptorsToken>
  );
});
